var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.17,
    height: 5.413,
    viewBox: "0 0 11.17 5.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1247.01 -403.148)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1430.568 713.323) rotate(-135)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 9.735,
    transform: "translate(346.848 87.964) rotate(45)",
    fill: "none",
    stroke: "#595d6e",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-1152.3-2986.126l-2.19,2,2.19,2",
    transform: "translate(102.948 -2578.272) rotate(180)",
    fill: "none",
    stroke: "#595d6e",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.743701f0c5b9ba63cb8e881b87050c99.svg";
export { ForwardRef as ReactComponent };